// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3e03I","mobileMenu":"Footer_mobileMenu__3h0vK","footerLogo":"Footer_footerLogo__ETcHM","footerContainer":"Footer_footerContainer__3rc0X"};